export default __webpack_public_path__ + "static/media/dreamstime_s_87359979.a911d89f.jpg";